import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'incidencias',
  getAllParams: ({
    from, completas, notificada, include, page, perPage, search, to, sort,
  }) => ({
    'filter[encargos_numero]': search,
    'filter[estado]': completas,
    'filter[notificada]': notificada,
    sort,
    from,
    include,
    page,
    per_page: perPage,
    to,
  }),
});
